// @ts-nocheck
// Greif UI Kit = line-settings
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const SettingsLine: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10.848 20.727q-.63 0-1.086-.398a1.6 1.6 0 0 1-.544-.979l-.2-1.416a3 3 0 0 1-.471-.22 7 7 0 0 1-.437-.275l-1.38.555q-.58.24-1.166.046a1.66 1.66 0 0 1-.91-.713l-1.152-1.932a1.38 1.38 0 0 1-.187-1.091q.135-.58.628-.953l1.18-.856a2 2 0 0 1-.018-.247v-.496q0-.118.017-.247l-1.18-.85a1.62 1.62 0 0 1-.63-.954 1.4 1.4 0 0 1 .19-1.096l1.152-1.927q.324-.513.907-.71a1.6 1.6 0 0 1 1.163.043l1.397.556q.215-.145.44-.273.225-.126.456-.218l.201-1.421q.09-.587.544-.985a1.6 1.6 0 0 1 1.086-.397h2.304q.63 0 1.086.397.454.399.544.985l.2 1.421q.249.092.471.218.223.128.437.273l1.38-.556a1.6 1.6 0 0 1 1.166-.043q.585.197.91.71l1.152 1.927q.325.517.19 1.096t-.63.953l-1.186.85q.018.13.017.248V12q0 .13-.002.248a1 1 0 0 1-.037.248l1.185.85q.497.373.63.953.135.579-.189 1.096l-1.175 1.932a1.68 1.68 0 0 1-.907.71 1.6 1.6 0 0 1-1.163-.043l-1.352-.555q-.215.145-.44.274t-.456.22l-.201 1.417q-.09.581-.544.98a1.6 1.6 0 0 1-1.086.397zm.316-1.946h1.644l.318-2.256a5.3 5.3 0 0 0 1.305-.505q.605-.335 1.097-.825l2.209.877.807-1.362-1.907-1.38q.112-.31.162-.646a4.6 4.6 0 0 0 0-1.368 3.3 3.3 0 0 0-.162-.646l1.918-1.38-.818-1.362-2.203.898a4.8 4.8 0 0 0-1.098-.846 5 5 0 0 0-1.31-.505l-.29-2.256H11.18l-.302 2.25a5.06 5.06 0 0 0-2.423 1.336l-2.198-.877-.813 1.362 1.901 1.354a4 4 0 0 0-.161.659q-.05.328-.05.697 0 .348.05.678.05.332.161.662l-1.901 1.37.813 1.362 2.198-.893a4.9 4.9 0 0 0 1.108.84q.612.34 1.315.511z"
            />
            <path
                fill="currentColor"
                d="M13.073 12c0-.567-.48-1.026-1.073-1.026s-1.073.46-1.073 1.026.48 1.026 1.073 1.026 1.073-.46 1.073-1.026m2.147 0c0 1.7-1.442 3.08-3.22 3.08S8.78 13.7 8.78 12 10.222 8.92 12 8.92s3.22 1.38 3.22 3.08"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export const SettingsLineOffset: IconOffset = {
    vertical: 13, // Store Custom Code
    horizontal: 13, // Store Custom Code
};

export default React.memo(SettingsLine);
